import { useNavigate } from "react-router-dom";
import useAppState from "../../../context/AppContext";
import { APP_RETIREMENT_URLS, ERROR_MESSAGES, PROPOSITION_DOC_TYPES } from "../../../const/AppConst";
import StickButtonsBloc from "../../common/StickButtonsBloc";
import { useForm } from "react-hook-form";
import UploadDocumentTemplate from "../../../components/common-template/UploadDocumentTemplate";
import { IDocumentType, IUploadedDoc } from "../../../context/model";
import { getInfoRetirementSteps } from "../../../utils/utils";
import GeneralDataProtectionBloc from "../../common/GeneralDataProtectionBloc";
import * as Yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup";
type InfoIdentityBlocFormData = {
  'LAST_EMPLOYER_PROOF': IUploadedDoc[];
  // pensionServiceCode: string
}

const requiredDocuments = PROPOSITION_DOC_TYPES.find(doc=> doc.code === 'LAST_EMPLOYER_PROOF') as IDocumentType

export default function REInfoLastEmployeeDocBloc() {

  const navigate = useNavigate();
  const {
    state: { familyDoc, additionalData, infoSteps, showModal, proposition, hasReduction},
    dispatch
  } = useAppState();
  const validationSchema = Yup.object().shape({
      'LAST_EMPLOYER_PROOF': Yup.array().min(1).required(ERROR_MESSAGES.requiredMsg),
    });
    const {
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm<InfoIdentityBlocFormData>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
      'LAST_EMPLOYER_PROOF': familyDoc.filter(
        (doc:any)=> doc.fileType === requiredDocuments.code),
    },
     resolver: yupResolver(validationSchema), 
  });

  const onNextAction = async (data: InfoIdentityBlocFormData) => {
   
    
    const nextUrl =(additionalData?.hasChild ||additionalData?.hasPartner || hasReduction) 
                   ? APP_RETIREMENT_URLS.infoFamilyDocPage 
                   : APP_RETIREMENT_URLS.retirementRecapPage;
   
      const hasDocFamilyStep = getInfoRetirementSteps
        (infoSteps, "INFO_FAMILY_DOC", 
          (additionalData?.hasChild ||additionalData?.hasPartner || hasReduction) ??false,
          "INFO_LASTEMPLOYEE_DOC"
        );
    
        if (hasDocFamilyStep.hasChanged) {
          dispatch({type: "UPDATE_STEPS", 
            steps: hasDocFamilyStep.infoSteps
          })
        }
    dispatch({type: 'NEXT_INFO_STEP', path: nextUrl});
    

    navigate({
        pathname: nextUrl,
        search: `?id=${proposition!.propositionId}`,
    });         
  }

  
  const onPreviousAction = async () => {
    const url = APP_RETIREMENT_URLS.infoRetirementDocPage
    dispatch({type: 'BACK_INFO_STEP', path: url});
    navigate({
        pathname: url,
        search: `?id=${proposition!.propositionId}`,
    });         
  }

  return (
    <form style={{width: '100%'}}>    
      <UploadDocumentTemplate
        requiredDocuments={requiredDocuments}
        errors= {errors}
        isUploadMultipe= {true}
        setValue={setValue}  
        hasRequired={true}
        tooltip={"Pour les fonctionnaires : arrêté ministériel indiquant la date de début de retraite + dernier bulletin de salaire (dont la date doit être en cohérence avec le début de retraite). \n Pour les non fonctionnaires : Notification de retraite (qui porte la date de début) + dernier bulletin de salaire (dont la date doit être en cohérence avec le début de retraite). \n Pour tous : attestation sur l’honneur attestant de l’absence de reprise d’une activité rémunérée"}         
      />

      {!showModal &&<StickButtonsBloc 
        showPreviousButton={true} 
        disabledPreviousButton={false} 
        nextAction={handleSubmit(onNextAction)} 
        showNextButton={true} 
        previousAction={onPreviousAction}/> }
      
    </form>
 
  )
}